import React from 'react';

import { Spacer } from '@repo/ui/components/Spacer';
import { Button } from '@repo/ui-kit/components/core/Button';
import { H1, P1 } from '@repo/ui-kit/components/core/Typography';

import { useSubscriptionSuccessTracking } from '../Subscription';

import { Wrapper, LeftColumn, RightColumn, Image } from './styles';
import { SuccessModalContentProps } from './types';

// TODO remove after https://app.clickup.com/t/86bwxdtkd (should be moved to the subscription success modal)

const SuccessModalContent: React.FC<SuccessModalContentProps> = ({
  onSuccess,
  onSuccessLabel = 'Start Creating',
  onSuccessMessage = (
    <>
      Your payment was successful. You can now enjoy all extra features. Visit
      the{' '}
      <a href="/user/settings/subscription" target="_blank">
        Payment & Billing
      </a>{' '}
      page for managing your billing information.
    </>
  ),
}) => {
  useSubscriptionSuccessTracking();
  return (
    <Wrapper>
      <LeftColumn>
        <H1>Payment Successful</H1>
        <Spacer height="12px" />
        <P1>{onSuccessMessage}</P1>
        <Spacer height="24px" />
        {onSuccess && (
          <Button
            name="successModalContinueButton"
            width="auto"
            onClick={onSuccess}
          >
            <Button.Label>{onSuccessLabel}</Button.Label>
          </Button>
        )}
      </LeftColumn>
      <RightColumn>
        <Image alt="Payment Successful" src="/images/success.svg" />
      </RightColumn>
    </Wrapper>
  );
};

export default SuccessModalContent;
